module.exports = __webpack_public_path__ + "img/1-lg.1a19fde7.jpg";